import { useNavigate } from "react-router-dom";
import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";
import { Type } from "@shared/ui/Type";
import PanelTitle from "@shared/ui/PanelTitle";

export function OnboardingComplete() {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/dashboard");
  };

  return (
    <PanelTitle
      title="You're Done!"
      description="Stay tuned for an email from admin@pollinator.com with information about October’s program."
      className="flex-1"
      isInverted
    >
      <Type variant="body1" className="text-brand-800 md:text-brand-100">
        Follow us at{" "}
        <a
          href="https://www.instagram.com/pollinator_coop/"
          target="_blank"
          className="underline"
          data-testid="onboarding-complete-instagram-link"
        >
          @pollinator_coop
        </a>
        .
      </Type>
      <ActionButtonsGroup
        onPrimaryClick={handleContinue}
        primaryButtonText={"Continue to Dashboard"}
        theme={"dark"}
      />
    </PanelTitle>
  );
}

export default OnboardingComplete;
